export var AccountRole;
(function (AccountRole) {
    AccountRole["REGISTERED"] = "REGISTERED";
    AccountRole["CUSTOMER"] = "CUSTOMER";
    AccountRole["B2B"] = "B2B";
    AccountRole["SHOP"] = "SHOP";
    AccountRole["BRANDSHOP"] = "BRANDSHOP";
})(AccountRole || (AccountRole = {}));
//# sourceMappingURL=AccountRole.enum.js.map